import React from 'react';

/**
 * Compact usage bar shown in page headers.
 * max === -1 means unlimited (dev / non-SaaS company).
 */
export default function UsageIndicator({ current, max, label }) {
  if (max === -1 || max == null) return null;  // unlimited — don't show

  const pct    = max > 0 ? Math.min(100, Math.round((current / max) * 100)) : 0;
  const color  = pct >= 100 ? 'var(--color-danger)'
               : pct >= 90  ? '#C53030'
               : pct >= 75  ? 'var(--color-warning)'
               : 'var(--color-success)';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
      <span style={{ fontSize: '12px', color: 'var(--color-text-muted)' }}>
        {label}: <strong style={{ color }}>{current}</strong> / {max}
      </span>
      <div style={{ width: '80px', height: '5px', background: 'var(--color-border)', borderRadius: '999px', overflow: 'hidden' }}>
        <div style={{
          height: '100%', width: `${pct}%`,
          background: color, borderRadius: '999px',
          transition: 'width 0.3s',
        }} />
      </div>
      {pct >= 90 && (
        <span style={{ fontSize: '11px', color, fontWeight: 600 }}>
          {max - current} left
        </span>
      )}
    </div>
  );
}
